type BuildInfo = {
  buildNo: string
  buildTime?: string
}

export const buildInfo: BuildInfo = {
  buildNo: '8_0',
  buildTime: '2026-11-03T14:13:39.641Z',
}
